app.ArchivedVacancyList = (
    function () {
        var vacancies = {
            Index: function () {

                $(document).on("component-bind-view-mode-complete-ArchivedVacanciesGrid",
                    function () {
                        $(".duplicateVacancyButton").on("click",
                            function () {
                                var vacancyId = $(this).data("vacancy-id");
                                util.console.log(vacancyId);
                                //get the duplicate modal and set the vacancy Id
                                $("#duplicateVacancyButton").attr("data-vacancy-id", vacancyId);
                                $("#confirmDuplicateVacancy").modal("show");
                            });
                    });
            }
        };
        return vacancies;
    }()
);